import Backbone from 'backbone';

let LayerModel = Backbone.Model.extend(
  /**
   * @lends LayerModel */
  {
    /**
     * @memberOf module:Layers 
     * @class LayerModel
     * @classdesc A Backbone model for layers. Handle layer properties: active, visible, loading
     * @extends Backbone.Model
     */
    initialize() {
      this.bindEvents();
    },
    /**
     * Bind the events to listen
     * @function
     * @fires LayerModel#change:active
     */
    bindEvents() {
      this.on('change:active', (model) => {
        if (model.get('active') === false) {
          this.set('visible', false);
        }
      });
    },
    /**
     * Change the property 'active' 
     * @function
     */
    toggle: function() {
      this.set('active', !this.get('active'));
    },

    /**
     * Set true the property 'active' 
     * @function
     */
    activate: function() {
      this.set('active', true);
    },

    /**
     * Set false the property 'active' 
     * @function
     */
    deactivate: function() {
      this.set('active', false);
    },
    /**
     * Get the property 'active' 
     * @function
     *  @returns {boolean} If layer is active
     */
    isActive: function() {
      return this.get('active');
    },

    /**
     * Get the property 'visible' 
     * @function
     *  @returns {boolean} If layer is visible
     */
    isVisible: function() {
      return this.get('visible');
    },

    /**
     * Set false the property 'visible' 
     * @function
     */
    hide() {
      this.set('visible', false);
    },

    /**
     * Set true the property 'visible' 
     * @function
     */
    show() {
      this.set('visible', true);
    }

  });

export default LayerModel;



// WEBPACK FOOTER //
// ./lmm-widget/src/layers/types/_base/models/LayerModel.js